import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import ReactTooltip from 'react-tooltip';
import { removeWidgetFromDashboard } from '../../../../../actions/reports';
import MLIcon from '../../../../../../components/MLIcon/MLIcon';
import {
  WIDGET_TYPE_TIME_SCORE_CHART,
  WIDGET_TYPE_TIME_ATTEMPTS_CHART,
  WIDGET_TYPE_COMPLETED_ASSIGNMENT,
  isSRLWidget as isSRLWidgetFn,
} from '../../../../constants';
import style from './QQHeader.module.css';
import MoreMenu from '../MoreMenu/MoreMenu';
import BetaBadge from '../BetaBadge/BetaBadge';
import { getConfigObject } from '../../../../../util/config';


const StyledMenuItem = withStyles({
  root: {
    height: '44px',
    color: 'var(--prs-c-primary)',
    '&:hover': {
      color: 'var(--white)',
      background: 'var(--prs-c-primary)',
      '& svg': {
        fill: 'var(--white)',
      },
    },
    '& svg': {
      paddingRight: '10px',
      fill: 'var(--prs-c-primary)',
    },
  },
})(MenuItem);


const QQHeader = ({
  title,
  subTitle,
  subTitle2,
  iconType,
  isDetailView,
  courseId,
  dashboardWidgetId,
  removeDashboardWidget,
  handleEditClick,
  showInsightInfo,
  widgetType,
  beta,
  preventFixedHeight,
  preventWidthOverflow,
  isSRLWidget,
}) => {
  const detailClass = isDetailView ? style.detailView : '';

  const handleClickMenu = (action) => {
    switch (action) {
      case 'remove':
        removeDashboardWidget(courseId, dashboardWidgetId);
        break;
      case 'edit':
        handleEditClick();
        break;
      case 'showCalcInfo':
        showInsightInfo();
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    setTimeout(() => {
      ReactTooltip.rebuild();
    }, 800);
  }, []);


  const menuItems = [
    <StyledMenuItem className={style.menuItem} onClick={() => handleClickMenu('edit')} key={`${dashboardWidgetId}_menu_edit_widget`}>
      <MLIcon
        type="gear"
      />
      Edit insight
    </StyledMenuItem>,
    <StyledMenuItem onClick={() => handleClickMenu('remove')} key={`${dashboardWidgetId}_menu_remove_widget`}>
      <MLIcon
        type="trash"
      />
      Remove insight
    </StyledMenuItem>,
  ];

  if (widgetType === WIDGET_TYPE_TIME_SCORE_CHART || widgetType === WIDGET_TYPE_TIME_ATTEMPTS_CHART) {
    menuItems.push(
      <StyledMenuItem onClick={() => handleClickMenu('showCalcInfo')} key={`${dashboardWidgetId}_menu_info_widget`}>
        <MLIcon
          type="info_outline"
        />
        How is this calculated?
      </StyledMenuItem>
    );
  }

  const conditionallyRenderMenu = () => {
    if (!isSRLWidgetFn(widgetType)) {
      return (
        <MoreMenu>
          {menuItems}
        </MoreMenu>
      );
    }
    return null;
  };

  const renderInfoIcon = () => {
    const showInfoIcon = [
      WIDGET_TYPE_TIME_SCORE_CHART,
      WIDGET_TYPE_TIME_ATTEMPTS_CHART,
      WIDGET_TYPE_COMPLETED_ASSIGNMENT,
    ].includes(widgetType);

     // This prevents multiple renders of the tooltip
     const randomKey = Math.random().toString(36).substring(7);

    if (showInfoIcon) {
      return (
        <>
          <MLIcon
            type="info_outline"
            role="button"
            onClick={() => handleClickMenu('showCalcInfo')}
            data-for={`info-button-${randomKey}`}
            data-tip="How is this calculated?"
            className={style.infoTooltip}
          />
          <ReactTooltip
            id={`info-button-${randomKey}`}
            place="left"
            className={style.infoTooltip}
            effect="solid"
          />
        </>
      );
    }
    return null;
  };



  const { FF_REPORTS_V2 } = getConfigObject();

  return (
    <React.Fragment>
      <div className={`${style.qqInsightsCardTitleWrapper} ${detailClass} ${preventFixedHeight ? style.autoHeight : ''} ${preventWidthOverflow && style.boxSizing}`}>
        <div className={style.qqInsightsCardTitleIcon}>
          <MLIcon
            width="24px"
            height="24px"
            className={style.thinkIcon}
            type={iconType}
          />
        </div>
        <div className={style.qqInsightsCardTitleTextWrapper}>
          <div className={style.qqInsightsCardTitle} title={title}>
            <div className={style.qqInsightsCardMainTitle}>
              <h2 className={`${isSRLWidget ? style.qqInsightsCardMainTitleBold : ''}`}>
                {title} {!FF_REPORTS_V2 && beta && <BetaBadge />}
              </h2>
              <div className={style.qqInsightsCardSubTitle} id="insights-card-subheader">
                {subTitle}
                <div>{subTitle2}</div>
              </div>
            </div>
            {FF_REPORTS_V2 ? renderInfoIcon() : conditionallyRenderMenu()}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

QQHeader.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  subTitle2: PropTypes.node,
  iconType: PropTypes.string,
  courseId: PropTypes.string.isRequired,
  dashboardWidgetId: PropTypes.number,
  removeDashboardWidget: PropTypes.func,
  isDetailView: PropTypes.bool,
  handleEditClick: PropTypes.func,
  showInsightInfo: PropTypes.func,
  widgetType: PropTypes.string,
  beta: PropTypes.bool,
  preventFixedHeight: PropTypes.bool,
  preventWidthOverflow: PropTypes.bool,
  isSRLWidget: PropTypes.bool,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  removeDashboardWidget: removeWidgetFromDashboard,
}, dispatch);

export default connect(null, mapDispatchToProps)(QQHeader);
